// @flow
import React from "react";
import { useSelector } from "react-redux";

import { getUserNames } from "src/reducers";
import { setChatroomNotificationAutomatorFilter } from "src/actions/chatroom";
import Checkbox from "src/components/Unifize/Checkbox";
import { MenuItem } from "src/components/Unifize/Menu/MenuItem";

import type {
  UID,
  UserNames,
  Action,
  ChatroomNotificationFilter,
} from "src/types";

import { CheckboxesContainer } from "./styles";
import FilterSubmenu from "./FilterSubmenu";

type Props = {
  dispatch: (action: Action, payload: any) => void,
  automatorFilter: $PropertyType<ChatroomNotificationFilter, "automators">,
  automatorUIDs: Array<UID>,
  menuRef: React$ElementRef<any>,
};

const AutomatorsMenu = ({
  dispatch,
  automatorFilter,
  automatorUIDs,
  menuRef,
}: Props) => {
  const allUserNames: UserNames = useSelector(({ app }) => getUserNames(app));

  return (
    <FilterSubmenu menuRef={menuRef}>
      <CheckboxesContainer>
        {automatorUIDs.map((automator, index) => (
          <MenuItem
            key={`automatorFilterMenu_${index}_${automator}`}
            padding="0 0.5rem"
            height="xl"
            hoverColor="rgba(133, 133, 133, 0.05)"
            display="inline"
          >
            <Checkbox
              label={allUserNames[automator]?.displayName ?? "Unknown"}
              checked={!automatorFilter[automator]}
              onChange={(checked) => {
                if (!checked) {
                  dispatch(
                    setChatroomNotificationAutomatorFilter({
                      ...automatorFilter,
                      [automator]: true,
                    }),
                  );
                } else {
                  dispatch(
                    setChatroomNotificationAutomatorFilter({
                      ...automatorFilter,
                      [automator]: false,
                    }),
                  );
                }
              }}
              labelFullWidth
              height="100%"
            />
          </MenuItem>
        ))}
      </CheckboxesContainer>
    </FilterSubmenu>
  );
};

export default AutomatorsMenu;
